import React, { useState, useEffect } from "react";
import "./Confidentiality.css";
import { useNavigate } from "react-router-dom";
import logo from "./media/logo.png";
import QRCode from "./media/qr_code.svg";
import ConfidentialityAnimation from "./ConfidentialityAnimation"; 

const NAV_ITEMS = [ { label: "About Us", path: "/about", type: "page" }, { label: "Our Team", path: "/team", type: "page" }, { label: "Services", path: "/#services", type: "scroll" }, { label: "Contact", path: "/contact", type: "page" } ];

function Confidentiality() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.type === "scroll") {
        navigate("/");
        setTimeout(() => { document.querySelector(item.path.replace("/", "")).scrollIntoView({ behavior: "smooth" }); }, 100);
    } else {
        navigate(item.path);
        window.scrollTo(0, 0);
    }
  };

  return (
    <div className="App confidentiality-page-wrapper">
      <div className={`dimming-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>
      <header className={`App-header ${scrolled ? "scrolled" : ""}`}>
        <a className="logo" href="/" onClick={(e) => { e.preventDefault(); navigate("/"); }}><img src={logo} alt="Logo" className="header-logo" /></a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}><div className="bar"></div><div className="bar"></div><div className="bar"></div></div>
      </header>
      <nav className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <ul>{NAV_ITEMS.map((item, i) => <li className="dropdown-item" key={i}><a onClick={() => handleNav(item)}>{item.label}</a></li>)}</ul>
      </nav>

      <section className="confidentiality-hero">
        <div className="container">
          <h1>Confidentiality Pledge</h1> 
          <div className="confidentiality-divider"></div>
        </div>
      </section>

      <section className="section white-bg">
        <div className="container split-layout">
          <div className="text-content">
            <h2>Our Promise to You</h2>
            <p>We are committed to:</p>
            <ul className="bullet-list">
              <li>Maintaining the strictest confidentiality of all information provided by our clients.</li>
              <li>Using such information solely for the purpose of executing our clients' work.</li>
              <li>Ensuring that all processes and outcomes related to our clients' work remain strictly confidential.</li>
            </ul>
          </div>
          <div className="animation-content">
             <ConfidentialityAnimation />
          </div>
        </div>
      </section>

      <footer className="App-footer">
        <div className="qr-box"><img src={QRCode} alt="QR" /></div>
        <p>© 2025 MERKEL & ASSOCIATES ADVOCATES.</p>
      </footer>
    </div>
  );
}
export default Confidentiality;